// Legacy UpdateConsigneeInfo: consignee fields and PO Number are overwritten (blank when unset).
export const applyConsigneeDefaults = (consignee: any, setValue: any) => {
  if (!consignee) return;
  setValue('consigneeName', consignee.consigneeName ?? '');
  setValue('consigneeNumber', consignee.consigneeNumber ?? '');
  setValue('consigneeEmail', consignee.consigneeEmail ?? '');
  setValue('consigneePhone', consignee.consigneePhone ?? '');
  setValue('consigneeFax', consignee.consigneeFax ?? '');
  setValue('poNumber', consignee.poNumber ?? '');
};
